module.exports = require("npm:array.prototype.findindex@1.0.0/index.js");